import { useLanguage } from '../contexts/LanguageContext';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Seo } from '../components/seo/Seo';

export default function Legal() {
    const { language } = useLanguage();
    const navigate = useNavigate();
    const t = language === 'de';

    return (
        <div className="p-4 lg:p-8 pb-24 lg:pb-8 pt-safe" data-testid="legal-page">
            <Seo
                title={t ? 'Impressum & Datenschutz' : 'Legal Notice & Privacy'}
                description={t
                    ? 'Impressum, Datenschutz und rechtliche Hinweise zu BESTBUDDY – betrieben von der MYSYMP AG, Nottwil, Schweiz.'
                    : 'Legal notice, privacy policy and legal information about BESTBUDDY – operated by MYSYMP AG, Nottwil, Switzerland.'}
                path={language === 'en' ? '/en/legal' : '/legal'}
                language={language}
                withHreflang
            />
            <div className="max-w-3xl mx-auto space-y-8">
                <Button variant="ghost" onClick={() => navigate(-1)} className="gap-2 mb-4">
                    <ArrowLeft className="w-4 h-4" /> {t ? 'Zurück' : 'Back'}
                </Button>
                <section id="impressum">
                    <h1 className="font-display text-3xl font-bold mb-6">Impressum</h1>
                    <div className="space-y-4 text-sm leading-relaxed text-muted-foreground">
                        <div><h3 className="font-bold text-foreground mb-1">Kontaktdaten</h3><p>MYSYMP AG<br/>Studenstrasse 14B<br/>6207 Nottwil<br/>Schweiz</p></div>
                        <div><p>Email: <a href="mailto:info@mysymp.ch" className="text-primary hover:underline">info@mysymp.ch</a><br/>Web: <a href="https://www.mysymp.ch" className="text-primary hover:underline" target="_blank" rel="noopener noreferrer">www.mysymp.ch</a></p></div>
                        <div><h3 className="font-bold text-foreground mb-1">Vertretungsberechtigte Personen</h3><p>Isidoro Celentano, CEO / Founder</p></div>
                        <div><h3 className="font-bold text-foreground mb-1">Handelsregistereintrag</h3><p>MYSYMP AG, CHE-192.170.455</p></div>
                        <div><h3 className="font-bold text-foreground mb-1">Haftungsausschluss</h3><p>BESTBUDDY (bestbuddy.fun) ist ein Produkt der MYSYMP AG. Die Inhalte dienen der allgemeinen Information und ersetzen keine professionelle medizinische Beratung.</p></div>
                    </div>
                </section>
                <hr className="border-border" />
                <section id="datenschutz">
                    <h1 className="font-display text-3xl font-bold mb-6">{t ? 'Datenschutzerklärung' : 'Privacy Policy'}</h1>
                    <div className="space-y-6 text-sm leading-relaxed text-muted-foreground">
                        <div><h2 className="font-bold text-lg text-foreground mb-2">1. Verantwortliche Stelle</h2><p>MYSYMP AG, Studenstrasse 14B, 6207 Nottwil, Schweiz. Email: info@mysymp.ch</p></div>
                        <div><h2 className="font-bold text-lg text-foreground mb-2">2. Welche Daten bearbeiten wir?</h2><p>Stammdaten (Name, Email), Gesundheitsdaten (Schlaf, Ernährung, Fitness, Symptome), Nutzungsdaten, KI-Interaktionen mit Nanouk Coach.</p></div>
                        <div><h2 className="font-bold text-lg text-foreground mb-2">3. KI und Datenverarbeitung</h2><p>BESTBUDDY nutzt OpenAI GPT-4o. Daten werden nicht für KI-Training verwendet.</p></div>
                        <div><h2 className="font-bold text-lg text-foreground mb-2">4. Datensicherheit</h2><p>Verschlüsselte Passwörter (bcrypt), HTTPS, JWT-Authentifizierung.</p></div>
                        <div><h2 className="font-bold text-lg text-foreground mb-2">5. Ihre Rechte</h2><p>Auskunft, Löschung, Berichtigung, Datenexport (PDF), Widerruf jederzeit möglich.</p></div>
                        <div><h2 className="font-bold text-lg text-foreground mb-2">6. Cookies</h2><p>Nur localStorage für Auth-Tokens. Keine Marketing- oder Tracking-Cookies.</p></div>
                        <div><h2 className="font-bold text-lg text-foreground mb-2">7. Kontakt</h2><p>MYSYMP AG, Studenstrasse 14B, 6207 Nottwil. Aufsichtsbehörde: EDOEB.</p></div>
                        <p className="text-xs pt-4 border-t border-border">
                            Letzte Aktualisierung: Februar 2026
                            {' · '}
                            <a href={t ? '/terms' : '/en/terms'} className="text-primary hover:underline" data-testid="legal-terms-link">
                                {t ? 'Nutzungsbedingungen' : 'Terms of Service'}
                            </a>
                        </p>
                    </div>
                </section>
            </div>
        </div>
    );
}
